import React from 'react';
import {
  UpdateUsernameDto,
  useAuthControllerSetUsernameMutation,
} from '@/store/services/MidleNestApi.service';
import { errorHandler } from '@/utils/error.handler';
import {
  ErrorArea,
  Form,
  Input,
  ReformSetError,
  ReformSubmitHandler,
  Submit,
} from '@kodkafa/reform';
import { useTranslation } from 'react-i18next';
import { useProfile } from '@/hooks';
import { useDispatch } from 'react-redux';
import { systemActions } from '@/store/features';

export function ChangeUsernameView() {
  const { t } = useTranslation();
  const { profile, reloadProfile } = useProfile();
  const dispatch = useDispatch();
  // TODO what is user id?
  const [mutation] = useAuthControllerSetUsernameMutation();
  const handleSubmit: ReformSubmitHandler<UpdateUsernameDto> = async (
    data,
    setError: ReformSetError,
  ) => {
    await mutation(data)
      .unwrap()
      .then(() => {
        reloadProfile();
        gtag('event', 'change-username', { user: profile.id });
        dispatch(
          systemActions.pushMessage({
            message: t('Your username has been changed successfully.'),
          }),
        );
      })
      .catch((error) => errorHandler(error, setError));
  };

  // const { data, isLoading } = useAuthControllerAccountInfoQuery();
  return (
    <div className='flex flex-col h-full items-stretch dark:text-white'>
      <div className='grow-0 text-xl font-bold'>
        <h2>{t('Change Username')}</h2>
      </div>
      <div className='grow pt-4 pb-10 px-1 -mx-1 overflow-y-auto'>
        <Form
          onSubmit={handleSubmit}
          defaultValues={{ username: profile?.user?.username }}
          className='flex md:w-80'
          autoComplete='off'
        >
          <div>
            <Input
              name='username'
              label={t('Username')}
              className='dark:!bg-transparent dark:!border-[#FFDA68] dark:!text-white dark:placeholder:text-white/50 dark:ring-transparent'
              autoComplete='off'
            />
          </div>
          <ErrorArea />
          <div>
            <button
              type='submit'
              className='w-full font-semibold text-sm bg-blue-500 h-11 rounded-lg dark:bg-[#FFDA68] dark:text-[#151515]'
            >
              {t('Save')}
            </button>
          </div>
        </Form>
      </div>
    </div>
  );
}
